import React from 'react';
import PropTypes from 'prop-types';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import { prettyDate } from '../../../lib/time';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableRow from '@material-ui/core/TableRow';
import { makeStyles, withStyles } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';

const QuestionTableCell = withStyles((theme) => ({
  body: {
    color: theme.palette.primary.main,
    backgroundColor: theme.palette.common.white,
    fontSize: '0.8rem',
    fontWeight: 500,
    padding: '0.5rem 1rem',
    paddingRight: '2rem',
  },
}))(TableCell);

const AnswerTableCell = withStyles((theme) => ({
  body: {
    backgroundColor: theme.palette.common.white,
    fontSize: '0.8rem',
    padding: '0.5rem 1rem',
    paddingLeft: '2rem',
  },
}))(TableCell);

const useStyles = makeStyles(theme => ({
  root: {
    minWdith: '50rem',
  },
  table: {
    border: `1px solid ${theme.palette.common.silver}`,
  },
  text: {
    fontSize: '0.8rem',
  }
}));

const ServiceRequestDialog = ({open, handleClose, data}) => {
  const classes = useStyles();
  if (data === null) {
    return null;
  }
  return (
    <Dialog
      open={open}
      onClose={handleClose}
      className={classes.root}
    >
      <DialogContent>
        <TableContainer>
          <Table className={classes.table}>
            <TableBody>
              <TableRow>
                <QuestionTableCell>Request ID:</QuestionTableCell>
                <AnswerTableCell>{data.short_id}</AnswerTableCell>
              </TableRow>
              <TableRow>
                <QuestionTableCell>Request type:</QuestionTableCell>
                <AnswerTableCell>{data.group_type}</AnswerTableCell>
              </TableRow>
              {'provider_name' in data.relations ? (
                <TableRow>
                  <QuestionTableCell>Provider name:</QuestionTableCell>
                  <AnswerTableCell>{data.relations.provider_name}</AnswerTableCell>
                </TableRow>
              ) : null}
              <TableRow>
                <QuestionTableCell>Created at:</QuestionTableCell>
                <AnswerTableCell>{prettyDate(data.created_at)}</AnswerTableCell>
              </TableRow>
              <TableRow>
                <QuestionTableCell>Updated at:</QuestionTableCell>
                <AnswerTableCell>{data.updated_at === null ? 'Never' : prettyDate(data.updated_at)}</AnswerTableCell>
              </TableRow>
              <TableRow>
                <QuestionTableCell>The request is for:</QuestionTableCell>
                <AnswerTableCell>{data.detail.participant_type}</AnswerTableCell>
              </TableRow>
              <TableRow>
                <QuestionTableCell>Services required:</QuestionTableCell>
                <AnswerTableCell>
                  {data.detail.services.map((item) => (
                    <Typography key={item.name} className={classes.text}>
                      {item.name}{item.amount === 'NA' ? null : `, ${item.amount}`}
                    </Typography>
                  ))}
                </AnswerTableCell>
              </TableRow>
              <TableRow>
                <QuestionTableCell>Location:</QuestionTableCell>
                <AnswerTableCell>{data.detail.location}</AnswerTableCell>
              </TableRow>
              <TableRow>
                <QuestionTableCell>NDIS plan type:</QuestionTableCell>
                <AnswerTableCell>{data.detail.management_type}</AnswerTableCell>
              </TableRow>
              <TableRow>
                <QuestionTableCell>Age group</QuestionTableCell>
                <AnswerTableCell>{data.detail.age_group}</AnswerTableCell>
              </TableRow>
              <TableRow>
                <QuestionTableCell>Contact details:</QuestionTableCell>
                <AnswerTableCell>Email: {data.detail.contact.email}<br/>Phone: {data.detail.contact.phone}</AnswerTableCell>
              </TableRow>
              <TableRow>
                <QuestionTableCell>Considerations:</QuestionTableCell>
                <AnswerTableCell>
                  {'considerations' in data.detail ? (
                    data.detail.considerations.map((item, idx) => (
                      <Typography className={classes.text} key={idx}>
                        {item}
                      </Typography>
                    ))
                  ) : null}
                </AnswerTableCell>
              </TableRow>
              <TableRow>
                <QuestionTableCell>Other information:</QuestionTableCell>
                <AnswerTableCell>{data.detail.other}</AnswerTableCell>
              </TableRow>
            </TableBody>
          </Table>
        </TableContainer>
      </DialogContent>
      <DialogActions>
        <Button onClick={handleClose} color="primary" autoFocus>
          Close
        </Button>
      </DialogActions>
    </Dialog>
  );
};

ServiceRequestDialog.propTypes = {
  open: PropTypes.bool.isRequired,
  handleClose: PropTypes.func.isRequired,
  data: PropTypes.object,
};

export default ServiceRequestDialog;
